const PRINCIPLES = [
  {
    icon: 'ri-speed-up-line',
    tint: 'bg-primary-100 text-primary-600',
    title: '快而准',
    desc: '聚合多路公开信号，榜单每 3 秒自动刷新，热点升温的第一个迹象也能被捕捉。',
  },
  {
    icon: 'ri-emotion-laugh-line',
    tint: 'bg-accent-100 text-accent-700',
    title: '清而冷',
    desc: '只客观呈现热度曲线与涨跌，不替任何一方站队，瓜好不好吃你自己尝。',
  },
  {
    icon: 'ri-grid-fill',
    tint: 'bg-secondary-100 text-secondary-800',
    title: '全而杂',
    desc: '从娱乐八卦到财经科技，分类齐全、互为参照，一块瓜田吃不下就换一块。',
  },
];

const QUOTES = [
  {
    text: '上班摸鱼必刷，话题热度曲线一看就知道这事闹到哪一步了，再也不怕接不上同事的梗。',
    name: '爱熬夜的禾禾',
    role: '冲浪选手',
  },
  {
    text: '赛果刚出不到十分钟，快瓜就把绝杀名场面顶上来了，爆瓜预警真的很灵。',
    name: '篮球场守门员',
    role: '体育迷',
  },
];

export default function About() {
  return (
    <section id="about" className="scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-12">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-semibold text-primary-600 border border-primary-200">
              <i className="ri-sailboat-line" aria-hidden="true"></i>关于快瓜
            </div>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              让每个人都能<span className="text-primary-500">看懂风向</span>再开口
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
              快瓜是一个面向年轻网民的全网热榜聚合与吃瓜资讯站。我们把散落在各平台的飙升话题收拢到一处，
              用排名、热度值与曲线还原话题升温的全过程。快，是手段；看得清，才是目的——
              愿你在信息洪流里，也能吃得明白、聊得从容。
            </p>
            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3">
              {PRINCIPLES.map((p) => (
                <div key={p.title} className="rounded-xl border border-background-200 bg-background-50 p-4">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-lg text-lg ${p.tint}`}>
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-heading text-xl font-bold text-foreground-950">吃瓜群众的真实口碑</h3>
            {QUOTES.map((q) => (
              <figure
                key={q.name}
                className="rounded-xl border border-background-200 bg-background-50 p-4 md:p-5 transition hover:border-accent-200"
              >
                <blockquote className="text-sm md:text-base leading-relaxed text-foreground-700">
                  <i className="ri-double-quotes-l mr-1 text-accent-500" aria-hidden="true"></i>
                  {q.text}
                </blockquote>
                <figcaption className="mt-3 flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-base text-accent-700">
                    <i className="ri-user-heart-line" aria-hidden="true"></i>
                  </span>
                  <span>
                    <span className="block text-sm font-semibold text-foreground-900">{q.name}</span>
                    <span className="block text-xs text-foreground-500">{q.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
            <a
              href="#subscribe"
              className="mt-1 inline-flex items-center justify-center gap-1.5 rounded-xl bg-background-50 py-3.5 text-sm font-semibold text-primary-600 border border-background-300 transition hover:border-primary-300"
            >
              也想收到瓜报？免费订阅
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}